import styled from 'styled-components';
import {space, SpaceProps} from 'styled-system';

const Form = styled.form<SpaceProps>`
    ${space};
`

export default Form 